var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ConfigureConsts } from './configure-consts';
import { AppComponentBase } from './app-component-base';
import { AppConsts } from './AppConsts';
import { LocalizationHelper } from '../shared/helpers/localization-helper';
import { FullScreenHelper } from '../shared/common/full-screen-helper';
import * as _ from 'lodash';
var ConfigureComponentBase = /** @class */ (function (_super) {
    __extends(ConfigureComponentBase, _super);
    function ConfigureComponentBase(injector) {
        var _this = _super.call(this, injector) || this;
        _this.configureLocalizationSourceName = AppConsts.localization.configureLocalizationSourceName;
        _this.graphSettingEventName = ConfigureConsts.event.graphSettingEventName;
        _this.dynamicSettingEventName = ConfigureConsts.event.dynamicSettingEventName;
        _this.controlSettingEventName = ConfigureConsts.event.controlSettingEventName;
        _this.deviceLocalizationSourceName = AppConsts.localization.deviceLocalizationSourceName;
        _this.salesCenterLocalizationSourceName = AppConsts.localization.salesCenterLocalizationSourceName;
        return _this;
    }
    ConfigureComponentBase.prototype.getFBoxAlias = function () {
        return abp.features.getValue('Device.FBoxAlias');
    };
    ConfigureComponentBase.prototype.ld = function (key) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return LocalizationHelper.l(this.localization, this.deviceLocalizationSourceName, key, args);
    };
    ConfigureComponentBase.prototype.lf = function (key) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return LocalizationHelper.l(this.localization, AppConsts.localization.fboxLocalizationSourceName, key, args);
    };
    ConfigureComponentBase.prototype.lm = function (key) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return LocalizationHelper.l(this.localization, this.salesCenterLocalizationSourceName, key, args);
    };
    ConfigureComponentBase.prototype.lc = function (key) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return LocalizationHelper.l(this.localization, this.configureLocalizationSourceName, key, args);
    };
    ConfigureComponentBase.prototype.lr = function (key) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return LocalizationHelper.l(this.localization, AppConsts.localization.reportsLocalizationSourceName, key, args);
    };
    ConfigureComponentBase.prototype.lo = function (key) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return LocalizationHelper.l(this.localization, AppConsts.localization.organizationLocalizationSourceName, key, args);
    };
    ConfigureComponentBase.prototype.setElementFullScreen = function () {
        var de = document.documentElement;
        if (de.requestFullscreen) {
            de.requestFullscreen();
        }
        else if (de.mozRequestFullScreen) {
            de.mozRequestFullScreen();
        }
        else if (de.webkitRequestFullScreen) {
            de.webkitRequestFullScreen();
        }
    };
    ConfigureComponentBase.prototype.cancelElementFullScreen = function () {
        FullScreenHelper.exitFullScreen();
    };
    ConfigureComponentBase.prototype.variableChanged = function (changedValue, _variable) {
        if (_.isNil(changedValue)) {
            return;
        }
        if (changedValue.previousValue === changedValue.currentValue) {
            return;
        }
        if (changedValue.currentValue) {
            _variable = changedValue.currentValue;
        }
        else {
            _variable = changedValue.previousValue;
        }
    };
    return ConfigureComponentBase;
}(AppComponentBase));
export { ConfigureComponentBase };
